import React, { Suspense, lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const AlertsStatus = lazy(
  () => import('@pages/dashboard/Alerts/components/AlertsStatus'),
);
const AlertsOffers = lazy(
  () => import('@pages/dashboard/Alerts/components/AlertsOffers'),
);

export const AlertsRoutes: RouteObject = {
  handle: {
    label: 'Alerts',
    skipBreadCrumb: true,
  },
  children: [
    {
      path: '/dashboard/alerts-status',
      handle: {
        label: 'Status',
        disabled: true,
      },
      element: (
        <Suspense>
          <AlertsStatus />
        </Suspense>
      ),
    },
    {
      path: '/dashboard/alerts-offers',
      handle: {
        label: 'Offers',
        disabled: true,
      },
      element: (
        <Suspense>
          <AlertsOffers />
        </Suspense>
      ),
    },
  ],
};
